type ValueOf<T> = T[keyof T];

export function isFeedData(
  data: ValueOf<typeof window.__TRAVELGUIDE_INITIAL_STATE__>
): data is InitalStateFeed {
  return "oois" in data && !isCatalogData(data);
}

export function isCatalogData(
  data: ValueOf<typeof window.__TRAVELGUIDE_INITIAL_STATE__>
): data is InitalStateCatalog {
  return "oois" in data && "activity" in data;
}

export function isDetailData(
  data: ValueOf<typeof window.__TRAVELGUIDE_INITIAL_STATE__>
): data is InitalStateDetail {
  return "item" in data && "sections" in data && Array.isArray(data.sections);
}

export function loadInitialData(
  type: "feed",
  hydrationCallback: (
    data: InitalStateFeed,
    domNode: HTMLElement,
    rootNodeId: string
  ) => void
): void;
export function loadInitialData(
  type: "catalog",
  hydrationCallback: (
    data: InitalStateCatalog,
    domNode: HTMLElement,
    rootNodeId: string
  ) => void
): void;
export function loadInitialData(
  type: "detail",
  hydrationCallback: (
    data: InitalStateDetail,
    domNode: HTMLElement,
    rootNodeId: string
  ) => void
): void;
export function loadInitialData<
  T extends "feed" | "catalog" | "detail",
  D extends ValueOf<typeof window.__TRAVELGUIDE_INITIAL_STATE__>
>(
  type: T,
  hydrationCallback: (data: D, domNode: HTMLElement, rootNodeId: string) => void
) {
  if (typeof window.__TRAVELGUIDE_INITIAL_STATE__ === "undefined") {
    return;
  }
  const rootIds = Object.keys(window.__TRAVELGUIDE_INITIAL_STATE__).filter(
    (key) => key.search(new RegExp(`^travelguide-${type}-\\w+$`)) !== -1
  );
  for (const id of rootIds) {
    const domNode = document.getElementById(id);
    const data = window.__TRAVELGUIDE_INITIAL_STATE__[id] as D;

    if (!domNode) {
      console.error(`Travelguide: root node ${id} not found!`);
      continue;
    }
    if (
      (type === "feed" && !isFeedData(data)) ||
      (type === "catalog" && !isCatalogData(data)) ||
      (type === "detail" && !isDetailData(data))
    ) {
      console.error(
        `Travelguide: wrong type of data ('${type}') for rootNodeId='${id}'.`
      );
      continue;
    }

    hydrationCallback(data, domNode, id);
  }
}
